import React, { JSX } from "react";
import { Banner } from "../../interfaces/banner.interface";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import Icon from "@mdi/react";
import { Carousel } from "antd";
import SlickButtonFix from "./SlickButtonFix";

const Banners = (
  props: {
    banners: Banner[],
    previousArrowIcon: JSX.Element,
    nextArrowIcon: JSX.Element,
  }
) => {
  const { banners, previousArrowIcon, nextArrowIcon } = props;
  
  const bannerImage = (banner) => (
    <picture>
      <source media="(min-width: 600px)" srcSet={banner.desktopImage} />
      <source media="(max-width: 599px)" srcSet={banner.mobileImage} />
      <img src={banner.desktopImage} alt={banner.title} />
    </picture>
  )

  return (
    <div className="carousel-banners">
      <Carousel autoplay arrows infinite={banners.length>1}
        prevArrow={
          <SlickButtonFix>
            {previousArrowIcon}
          </SlickButtonFix>
        }
        nextArrow={
          <SlickButtonFix>
            {nextArrowIcon}
          </SlickButtonFix>
        }
      >
        {
          banners.map((banner:Banner, index)=>{
            // return <div className="banner" key={index} style={{backgroundImage: `url(${banner.desktopImage})`}}/>
            return <div className="banner" key={index}>
              {
                banner.url != "" ? (
                  <a href={banner.url} target={banner.target} rel="nofollow">
                    {bannerImage(banner)}
                  </a>
                ) : (
                  <>{bannerImage(banner)}</>
                )
              }
           
            </div>
          })
        }
      </Carousel>
    </div>
  )
}

export default Banners;